var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17923 1.64245C2.11032 1.60794 2.03292 1.59407 1.95632 1.6025C1.87972 1.61093 1.80719 1.64131 1.74745 1.68999C1.6877 1.73866 1.64329 1.80356 1.61955 1.87687C1.59581 1.95018 1.59375 2.02879 1.61363 2.10325L2.81203 6.59765C2.83183 6.67176 2.87252 6.73862 2.92926 6.79025C2.98599 6.84188 3.05638 6.87611 3.13203 6.88885L8.61603 7.80245C8.83923 7.84005 8.83923 8.16005 8.61603 8.19765L3.13283 9.11125C3.05704 9.12385 2.98648 9.15801 2.92959 9.20966C2.8727 9.2613 2.83188 9.32823 2.81203 9.40245L1.61363 13.8968C1.59375 13.9713 1.59581 14.0499 1.61955 14.1232C1.64329 14.1965 1.6877 14.2614 1.74745 14.3101C1.80719 14.3588 1.87972 14.3892 1.95632 14.3976C2.03292 14.406 2.11032 14.3922 2.17923 14.3576L14.1792 8.35765C14.2456 8.32439 14.3014 8.27333 14.3404 8.21018C14.3794 8.14703 14.4 8.07427 14.4 8.00005C14.4 7.92583 14.3794 7.85307 14.3404 7.78992C14.3014 7.72676 14.2456 7.6757 14.1792 7.64245L2.17923 1.64245Z",
    fill: "#171923"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/SendMessage.f6e03ea6483944185aebdb933b85ef13.svg";
export { ForwardRef as ReactComponent };